import {Controller} from "stimulus"
import $ from 'jquery';
import {validate_email} from "./validate_controller";
import Inputmask from "inputmask";


export default class extends Controller {
    connect() {
        let context = this
        $('#request_agency_app_country').select2({
            theme: "bootstrap",
            language: "es",
            placeholder: "Seleccione una opción",
            allowClear: true
        }).on('select2:select', function () {
            context.billing_address;

            let event = new Event('change', {bubbles: true})
            this.dispatchEvent(event);
        })

      $('#request_agency_app_tax_id_type').select2({
          theme: "bootstrap",
          language: "es",
          placeholder: "Seleccione una opción",
          allowClear: true
      }).on('change', function (e) {
          let target = $(`#${e.target.dataset.target}`)

          let im = '';

          if(e.target.value.isEmpty()){
              target.attr('disabled', true)
          }else{
              target.removeAttr('disabled')
          }

          target.val('');

          switch (e.target.value) {
              case 'SSN':
                  target[0].setAttribute('placeholder','XXX-XX-XXXX')
                  im = new Inputmask({ regex: '^\\d{3}-\\d{2}-\\d{4}$'})
                  im.mask(target)
                  break;
              case 'EIN':
                  target[0].setAttribute('placeholder','XX-XXXXXXX')
                  im = new Inputmask({ regex: '^\\d{2}-\\d{7}$' })
                  im.mask(target)
                  break;
              case 'ITIN':
                  target[0].setAttribute('placeholder','9XX-XX-XXXX')
                  im = new Inputmask({ regex: "^9\\d{2}-\\d{2}-\\d{4}$"})
                  im.mask(target)
                  break;
              case 'ATIN':
                  target[0].setAttribute('placeholder','XX-XXXXXXX')
                  im = new Inputmask({ regex: '^\\d{2}-\\d{7}$' })
                  im.mask(target)
                  break;
          }
      })
    }

    validate_form(e){
        let button = e.target.id
        let target = $('#'+e.target.dataset.validate);
        let required_field_input = target.find('input.required');
        let required_field_select = target.find('select.required');
        let required_field_checkbox = target.find('checkbox.required');

        let error = 0;
        required_field_input.each((index, elem) => {
            let field = $(elem)[0];
            let helper = $(field.parentNode).find('.helper-text');
            if (field.value.isEmpty()) {
                // helper.html('<p class="text text-danger">Este campo no puede estar vacío</p>');
                field.classList.add('is-invalid');
                error++;
            } else {
                let field_name = field.name

                if(field.name.includes('email')){
                    validate_email(field.value, field.id, null).then(r => {
                        if(!r){
                            error++;
                        }
                    })

                }
                else{
                    field.classList.remove('is-invalid');
                    helper.html('');
                }
            }
        });
        required_field_select.each((index, elem) => {
            let field = $(elem)[0];
            let helper = $(field.parentNode).find('.helper-text');
            if (field.value.isEmpty()) {
                if(field.classList.contains('select2-hidden-accessible')){
                    let select_2_field = $(field)[0].parentNode;
                    let parent_node = $(select_2_field).find('.select2-selection');
                    parent_node[0].classList.add('is-invalid');
                }
                // helper.html('<p class="text text-danger">Este campo no puede estar vacío</p>');
                $(field.parentNode).addClass("is-invalid");
                error++;
            } else {
                if(field.classList.hasOwnProperty('select2-hidden-accessible')){
                    if(field.classList.contains('select2-hidden-accessible')){
                        let select_2_field = $(field)[0].parentNode;
                        let parent_node = $(select_2_field).find('.select2-selection');
                        parent_node[0].classList.remove('is-invalid');
                    }
                }
                // helper.html('');
                $(field.parentNode).removeClass("is-invalid");
                // helper.html('');
            }
        });
        required_field_checkbox.each((index, elem) => {
            let checkbox = $(elem)[0];
            let helper = $(checkbox).find('.helper-text');
            if (checkbox.value.isEmpty()) {
                // helper.html('<p class="text text-danger">Este campo no puede estar vacío</p>');
                $(checkbox).addClass("is-invalid");

                error++;
            } else {
                helper.html('');
                $(checkbox).removeClass("is-invalid");
                // helper.html('');
            }
        });

        if(error === 0){
           target.submit();
        }
    }

    billing_address(e){
        let admin_user_type_billing_address = $('#request_agency_app_billing_address');
        let admin_user_type_address = $('#request_agency_app_address');
        let admin_user_type_street2 = $('#request_agency_app_street2');
        let admin_user_type_state = $('#request_agency_app_state');
        let admin_user_type_state_code = $('#request_agency_app_state_code');
        let admin_user_type_city = $('#request_agency_app_city');
        let admin_user_type_country = $('#request_agency_app_country');
        let admin_user_type_zip = $('#request_agency_app_zip');

        admin_user_type_billing_address.val(`${admin_user_type_address.val()} ${admin_user_type_street2.val()},  ${admin_user_type_city.val()} ${admin_user_type_state_code.val()}, ${admin_user_type_country.val()}, ${admin_user_type_zip.val()}`)
    }

}